"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import ErrorBoundary from "../errorboundary/ErrorBoundary.js";
import dynamic from "next/dynamic.js";
import { styled } from "styled-components";
//#region [Styles]
const SFacebookContainer = styled.div `
	max-width: 550px;
	margin: 1em auto;
`;
//#endregion
//#region [Component]
const DynamicFacebookEmbed = dynamic(() => import('react-social-media-embed').then((mod) => mod.FacebookEmbed), { ssr: false });
export default function Facebook({ value }) {
    if (!value?.fbPostUrl) {
        return null;
    }
    return _jsx(SFacebookContainer, { children: _jsx(ErrorBoundary, { children: _jsx(DynamicFacebookEmbed, { url: value.fbPostUrl, width: "100%" }) }) });
}
